import React from 'react';
import Link from 'react-router/lib/Link';
import PropTypes from 'prop-types';

import { getLinkPropsFromUrl } from 'common/src/app/util/urlUtils';
import { functionalComponentClassName } from 'common/src/app/util/componentClassNameUtils';
import ComponentType from 'common/src/app/data/enum/ComponentType';
import IconName from 'common/src/app/data/enum/IconName';
import DataTestidOverides from 'common/src/app/data/enum/DataTestidOverides';

import Icon from '../Icon';

const SlimmingWorldLogo = ({ link, width }) => (
  <Link
    aria-label="Home"
    className={functionalComponentClassName(ComponentType.ATOM, 'SlimmingWorldLogo')}
    data-testid={DataTestidOverides.LOGO}
    {...getLinkPropsFromUrl(link)}
  >
    <Icon name={IconName.SW_LOGO_PRIMARY} width={width || 94} />
  </Link>
);

SlimmingWorldLogo.propTypes = {
  link: PropTypes.string,
  width: PropTypes.number,
};

export default SlimmingWorldLogo;
